import styled from 'styled-components';
import colors from 'Styles/colors';

export const Wrapper = styled.div` 
  display: flex;
  flex-direction: column;
  min-height: 73px;
  height: 100%;
  width: 100%;
  ${({ disabled }) => disabled && 'opacity: 0.5'};
`;
Wrapper.displayName = 'Wrapper';

export const Title = styled.div`
  flex: 0 0 14px;
  margin-bottom: 5px;
  letter-spacing: 0.09px;
  user-select: none;
  text-transform: capitalize;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: ${({ disabled, required, isEmpty }) => (!disabled && required && isEmpty ? '#EA3158' : '#AFB1BC')};

  &::after {
    content: ${({ $asterisk }) => ($asterisk ? '"*"' : '""')};
    color: ${colors.redPink};
    margin-left: 5px;
    font-size: inherit;
    font-weight: bold;
  }
`;
Title.displayName = 'Title';

export const ErrorMessage = styled.div`
  flex: 0 0 12px;
  margin-top: 4px;
  user-select: none;
  text-transform: capitalize;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 10.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  color: #ea3158;
`;
ErrorMessage.displayName = 'ErrorMessage';

export const CustomInput = styled.input`
  flex: 1 1 0;
  width: 100%;
  border-style: solid;
  border-color: #afb1bc;
  border-width: 0px 0px 1px 0px;
  border-color: ${({
    disabled, error, required, isEmpty
  }) => ((error || (!disabled && required && isEmpty)) ? '#EA3158' : 'transparent')};
  padding: 0px 40px 0px 15px;
  font-size: 14.5px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.11px;
  color: ${({ theme }) => theme.textfield.text};
  background-color: ${({ theme }) => theme.textfield.background};
  &::placeholder {
    color: ${({ theme }) => theme.text.placeholder};
    font-size: 13.5px;
    font-weight: 300;
  }

  &:focus{
      background-color: ${({ theme }) => theme.textfield.focus};         

      &::placeholder {
          color: transparent;
      }
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }

  /* Chrome / Edge autofill */
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:active,
  &:-webkit-autofill:focus {
    -webkit-text-fill-color: ${({ theme }) => theme.textfield.text};
    caret-color: ${({ theme }) => theme.textfield.text};

    -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.textfield.background} inset;
    box-shadow: 0 0 0 1000px ${({ theme }) => theme.textfield.background} inset;

    transition: background-color 9999s ease-out 0s;
  }

  &:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px ${({ theme }) => theme.textfield.focus} inset;
    box-shadow: 0 0 0 1000px ${({ theme }) => theme.textfield.focus} inset;
  }

  /* Firefox */
  &[type=number] {
  -moz-appearance: textfield;
  }
`;
CustomInput.displayName = 'CustomInput';
